import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
export function Integrations() {
  const tools = ['CSV Upload', 'CRM', 'Meta Ads', 'Google Ads', 'Accounting', 'Phone', 'Scheduling', 'Email', 'Payment Platforms', 'Custom APIs'];
  return <section id="integrations" className="py-32 bg-secondary/30 border-y border-white/5 overflow-hidden" data-id="element-190">
      <div className="max-w-7xl mx-auto px-6" data-id="element-191">
        <div className="text-center mb-20" data-id="element-192">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-193">
            Everything eventually connects.
          </motion.h2>
        </div>

        <div className="relative max-w-5xl mx-auto mb-32" data-id="element-194">
          <div className="flex flex-wrap justify-center gap-4" data-id="element-195">
            {tools.map((tool, i) => <Fragment key={i} data-id="element-196">
                <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="bg-card border border-white/5 rounded-full px-6 py-3 text-sm font-medium text-textSecondary hover:text-white hover:border-white/20 transition-colors" data-id="element-197">
                  {tool}
                </motion.div>
                {i < tools.length - 1 && <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1 + 0.05
            }} className="flex items-center text-white/20" data-id="element-198">
                    ↓
                  </motion.div>}
              </Fragment>)}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: tools.length * 0.1
          }} className="bg-accent text-white rounded-full px-8 py-3 text-sm font-bold shadow-[0_0_30px_rgba(254,83,113,0.32)] w-full text-center mt-4" data-id="element-199">
              Everything.
            </motion.div>
          </div>
        </div>

        <div className="text-center" data-id="element-200">
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold" data-id="element-201">
            One dashboard.
            <br data-id="element-202" />
            <span className="text-textSecondary" data-id="element-203">Every metric.</span>
          </motion.h3>
        </div>
      </div>
    </section>;
}